// import DatePicker from '@stories/Components/Forms/DatePicker/DatePicker';
import FormField from '@stories/Components/Forms/FormField/FormField';
import Select from '@stories/Components/Forms/Select/Select';
import Textbox from '@stories/Components/Forms/Textbox/Textbox';
import React, { useRef, useState } from 'react';
import S from './HireFilter.styles';
import { ReactComponent as Search } from '@img/icons/search-button.svg';
import debounce from 'lodash/debounce';
import NewDatePicker from '@stories/Components/Forms/NewDatePicker/DatePicker';
const HireFilter = ({ labels, placeholders, searchTerm, onSearchTermChanged, onSearchClick, dropdownOptions, category, dateFrom, dateTo, onCategoryChanged, onDateFromChanged, onDateToChanged, selectedAccountId, primaryAccountId, secondaryAccountIds, onAccountChanged, }) => {
    const [_searchTerm, _setSearchTerm] = useState(searchTerm);
    const allAccountIds = [primaryAccountId, ...secondaryAccountIds];
    const debouncedChanged = useRef(debounce((value) => {
        onSearchTermChanged(value);
    }, 500));
    const handleSearchChangedInternal = (value) => {
        _setSearchTerm(value);
        debouncedChanged.current(value);
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Item, null,
            React.createElement(S.Label, null, labels.showLabel),
            React.createElement(Select, { selectedOption: dropdownOptions.find((x) => x.id === category)?.value || '', options: dropdownOptions, onClick: (index) => onCategoryChanged(dropdownOptions[index].id) })),
        React.createElement(S.Item, null,
            React.createElement(S.Label, null, labels.accountLabel),
            React.createElement(Select, { selectedOption: selectedAccountId.value, options: allAccountIds, onClick: (index) => onAccountChanged(allAccountIds[index]) })),
        React.createElement(S.Item, null,
            React.createElement(NewDatePicker, { startDate: dateFrom, label: `${labels.despatchFromLabel} - ${labels.despatchToLabel}`, onStartDateChanged: onDateFromChanged, endDate: dateTo, onEndDateChanged: onDateToChanged })),
        React.createElement(S.Item, null,
            React.createElement(S.Label, null, labels.searchLabel),
            React.createElement(FormField, { size: "default" },
                React.createElement(Textbox, { placeholder: placeholders.searchPlaceholder, onChange: (event) => handleSearchChangedInternal(event.currentTarget.value), onKeyDown: (event) => {
                        if (event.key.toLowerCase() === 'enter') {
                            event.preventDefault(); // Fixes bodyscrolllock issue
                            onSearchClick();
                        }
                    }, value: _searchTerm }),
                React.createElement(S.SearchButton, { onClick: onSearchClick },
                    React.createElement(Search, null))))));
};
export default HireFilter;
